import {session} from 'wix-storage';
import wixData from 'wix-data';


$w.onReady(function () {
	let choice = session.getItem("choice")
	let c1=choice[0]
	let c2=choice[1]
	let c3=choice[2]
	//$w('#text70').text=c1+c2+c3+""
	$w('#b'+c1).style.backgroundColor="green"
	$w('#b'+c2).style.backgroundColor="green"
	$w('#b'+c3).style.backgroundColor="green"

	for(let i=0; i<3; i++){
		wixData.get("abc", choice[i]+"")
		.then((number)=>{
			$w('#title'+(i+1)).text=number.title
			$w('#tips'+(i+1)).text=number.text
		})
	}



		
	
})